import React from 'react'
import { IonPage } from '@ionic/react'
import Home from 'ui/views/Home'
import { useRecentSubmissions } from 'hooks/submission'
import NavFooter from 'ui/components/menus/NavFooter'

const HomePage: React.FC = () => {
  const { data: submissions } = useRecentSubmissions()

  return (
    <IonPage>
      <Home submissions={submissions || []} />
      <NavFooter />
    </IonPage>
  )
}

export default HomePage
